import type { LabAbbreviation } from "@/configuration/transform-config";

export const LAB_ABBREVIATIONS: readonly LabAbbreviation[] = [
  {
    aliases: ["Comprehensive Metabolic Panel", "Comp Metabolic Panel", "CMP"],
    canonical: "CMP",
  },
  {
    aliases: [
      "CBC w/ diff",
      "CBC w/ diff auto",
      "CBC w/o diff",
      "CBC differential auto",
      "Complete Blood Count",
      "CBC",
    ],
    canonical: "CBC",
  },
  {
    aliases: ["Hemoglobin A1C", "HgA1c", "HgbA1C", "A1C"],
    canonical: "HgbA1C",
  },
  {
    aliases: ["Thyroid Stimulating Hormone", "TSH", "TSH Ultrasensitive"],
    canonical: "TSH",
  },
  {
    aliases: ["Free Triiodothyronine", "Free T3", "T3"],
    canonical: "T3",
  },
  {
    aliases: ["Thyroxine", "Free T4", "T4 Free", "T4"],
    canonical: "T4",
  },
  {
    aliases: ["Lipid Panel with Calculated LDL", "Lipid Panel", "Lipids"],
    canonical: "Lipids",
  },
  {
    aliases: ["Prostate-Specific Antigen", "PSA"],
    canonical: "PSA",
  },
] as const;
